export enum RoutesTypes {
  Customers = 'customers',
  Transfers = 'transfers',
  Organization = 'organization',
  Auth = 'auth',
  WalletVerification = 'wallet-verification',
  KycSuccess = 'kyc-success',
}
